import { http_client } from '@/plugins/http_client';
let urlBase = 'api';
let urlSanciones = '/sanciones';
let urlCatalogos = '/catalogos';

export const fetchExpediente = params => {
  return http_client(urlBase + urlSanciones + '/info-empleado', params, 'POST');
};

export const fetchTipoDocumentos = params => {
  return http_client(
    urlBase + urlCatalogos + '/documentos-tipos',
    params,
    'GET'
  );
};

export const fetchTiposReporte = (idEstado, params = {}) => {
  // catálogo de tipos de sanciones filtrado por estado
  const estadoId = Number(idEstado);
  const baseUrl = urlBase + urlCatalogos + '/sanciones-tipos';
  const url = Number.isInteger(estadoId) && estadoId > 0
    ? `${baseUrl}/${estadoId}`
    : baseUrl;

  return http_client(url, params, 'GET');
};

export const guardarSancion = data => {
  const formData = new FormData();
  // Agrega los campos normales
  for (const key in data) {
    if (key === 'archivos' && Array.isArray(data.archivos)) {
      // Agrega cada archivo individualmente, extrayendo el objeto File
      data.archivos.forEach(item => {
        if (item.archivo) {
          formData.append(
            'archivos[]',
            item.archivo,
            item.nombre || item.archivo.name
          );
        }
      });
    } else {
      formData.append(key, data[key] ?? '');
    }
  }
  return http_client(
    urlBase + urlSanciones + '/create-solicitud',
    formData,
    'POST',
    { 'Content-Type': 'multipart/form-data' }
  );
};

export const actualizarSancion = (idSancion, data) => {
  const isFormData = typeof FormData !== 'undefined' && data instanceof FormData;
  const body = isFormData ? data : JSON.stringify(data);
  const headers = isFormData ? undefined : { 'Content-Type': 'application/json' };
  return http_client(
    `${urlBase + urlSanciones}/${idSancion}/procede`,
    body,
    'POST',
    headers
  );
};

export const enviarDatosResolucion = data => {
  const isFormData = typeof FormData !== 'undefined' && data instanceof FormData;
  const body = isFormData ? data : JSON.stringify(data);
  const headers = isFormData ? undefined : { 'Content-Type': 'application/json' };
  return http_client(
    `${urlBase + urlSanciones}/resolucion/datos`,
    body,
    'POST',
    headers
  );
};

export default {
  fetchExpediente,
  fetchTiposReporte,
  guardarSancion,
  actualizarSancion,
  enviarDatosResolucion,
  fetchTipoDocumentos,
};
